import React, { useState } from 'react';
import {
    Box,
    Container,
} from '@mui/material';
import { FaServer, FaDesktop, FaHeartbeat, FaBell, FaChartLine } from 'react-icons/fa';

export default function WhyChooseWatchNod() {
    const [hoveredIndex, setHoveredIndex] = useState(null);

    const features = [
        {
            title: 'Easiest setup and Simple Dashboard',
            description: 'Hassle free setup and simple dashboard for Real-time and Predictive Monitoring to avoid downtime.',
            icon: <FaDesktop size={36} color="#2065D1" />,
        },
        {
            title: 'Real-time Monitoring',
            description: 'Monitor your servers in real-time to ensure optimal performance.',
            icon: <FaServer size={36} color="#2065D1" />,
        },
        {
            title: 'Server Health Metrics',
            description: 'Track important server health metrics to identify issues proactively.',
            icon: <FaHeartbeat size={36} color="#2065D1" />,
        },
        {
            title: 'Alerts and Notifications',
            description: 'Receive alerts and notifications when critical events occur.',
            icon: <FaBell size={36} color="#2065D1" />,
        },
        {
            title: 'Historical Data and Reports',
            description: 'Access historical data and generate detailed reports for analysis.',
            icon: <FaChartLine size={36} color="#2065D1" />,
        },
    ];

    return (
        <Container
            maxWidth="xl"
            sx={{
                pt: '2.5%',
                pb: '4.5%',
            }}
        >
            <Box display="flex" alignItems="center" justifyContent="center">
                <h2
                    style={{
                        color: '#002244',
                        fontSize: '2.8rem',
                        fontWeight: '700',
                        textAlign: 'center',
                        marginBottom: '60px',
                    }}
                >
                    Why Choose WatchNod?
                </h2>
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    gap: '20px',
                }}
            >
                {features.map((f, i) => (
                    <Box
                        key={i}
                        onMouseEnter={() => setHoveredIndex(i)}
                        onMouseLeave={() => setHoveredIndex(null)}
                        sx={{
                            ...styles.card,
                            ...(hoveredIndex === i ? styles.cardHover : {}),
                            width: {
                                xs: '100%',    // full width on very small screens
                                sm: '45%',     // 2 per row
                                md: '30%',     // 3 per row
                                lg: '260px',   // fixed width on large screen
                            },
                        }}
                    >
                        <div style={styles.icon}>{f.icon}</div>
                        <h3 style={styles.cardTitle}>{f.title}</h3>
                        <p style={styles.cardText}>{f.description}</p>
                    </Box>
                ))}
            </Box>

        </Container>

    );
}

const styles = {
    section: {
        backgroundColor: '#e6f0ff',
        paddingTop: '2.5%',
        paddingBottom: '4.5%',
        textAlign: 'center',
    },
    heading: {
        color: '#002244',
        fontSize: '3rem',
        marginBottom: '60px',
        fontWeight: '700',
    },
    cardWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '50px',
        justifyContent: 'center',
        margin: '0 auto',
    },
    card: {
        backgroundColor: 'white',
        border: '1px solid #0056b3',
        borderRadius: '13px',
        padding: '25px',
        boxShadow: '0 8px 20px rgba(0, 64, 128, 0.15)',
        textAlign: 'center',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    },
    cardHover: {
        transform: 'translateY(-8px)',
        boxShadow: '0 12px 28px rgba(0, 64, 128, 0.25)',
    },
    cardTitle: {
        color: '#004080',
        fontSize: '1.2rem',
        fontWeight: '600',
        marginBottom: '10px',
    },
    cardText: {
        color: '#003366',
        fontSize: '1rem',
        lineHeight: '1.6',
    },
    icon: {
        marginBottom: '15px',
    },
};